export const USER_DENIED_SIGNATURE = 4001
